<mat-toolbar color="accent" [style.display]="'flex'">
    <span class="spacer"></span>
    <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</mat-toolbar>
<app-card-search (cardClicked)="onRowClicked($event)" [overrideClick]="overrideRowClicked" [searchInventory]="searchInventory" [setQuery]="query" [deck]="data?.deck"></app-card-search>
